import { useQuery } from "@tanstack/react-query"
import { salesForceIntegrationQuery } from "../../lib/salesForce/salesForceIntegrationQuery"

export function useSalesForceIntegrationQuery(
  ...args: Parameters<typeof salesForceIntegrationQuery>
) {
  return useQuery(salesForceIntegrationQuery(...args))
}
